import axiosService from './axios-service';

export interface MlRecommendationDto {
    ipsToBlock: string[];
    applicationsToBlock: string[];
}

export interface MlRecommendationData {
    ipsToBlock: string[];
    applicationsToBlock: string[];
    serviceId: number;
    connectionName?: string;
    recommendationWasApplied?: boolean;
}

export interface FwVersionResponseDto {
    metadataDao: any;
    fwVersionContentDto: any;
}

class MlRecommendationService {
    public async applyMlRecommendation(customerId: number, serviceId: number, mlRecommendationDto: MlRecommendationDto): Promise<FwVersionResponseDto> {
        const response = await axiosService.post(`/api/firewall/customer/${customerId}/service/${serviceId}/apply-ml-recommendation`, mlRecommendationDto);
        return response?.data;
    }
    public async getMlRecommendations(customerId: number, serviceId: number): Promise<MlRecommendationDto> {
        const response = await axiosService.get(`/api/firewall/customer/${customerId}/service/${serviceId}/ml/recommendations`);
        return response?.data;
    }

    public async getMlState(customerId: number): Promise<boolean> {
        const response = await axiosService.get(`/api/firewall/customer/${customerId}/ml/recommendation/state`);
        return response?.data;
    }

    public async setMlState(customerId: number, enableMl: boolean): Promise<boolean> {
        const response = await axiosService.put(`/api/firewall/customer/${customerId}/ml/recommendation/state`, {enableMl});
        return response?.data;
    }
}

const mlRecommendationService = new MlRecommendationService();
export default mlRecommendationService;
